import axios from 'axios';

const getApiUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8000/';
  }
  return 'https://api.arjanpeyman.ir/';
};

export const api_url = getApiUrl();

const api = axios.create({
  baseURL: api_url,
  withCredentials: true,
});

let isRefreshing = false;
let waiters = [];

// اگر در «ورود جایگزین» بودیم و نشستش از کار افتاد، نشست ادمین را برگردان
// و به پنل ادمین برو (نه صفحهٔ ورود). اگر پشتیبانی نبود false می‌دهد.
const restoreImpersonation = () => {
  const raw = localStorage.getItem('impersonate_backup');
  if (!raw) return false;
  try {
    const b = JSON.parse(raw);
    localStorage.removeItem('impersonate_backup');
    if (b.access) localStorage.setItem('access', b.access);
    if (b.refresh) localStorage.setItem('refresh', b.refresh);
    try { sessionStorage.removeItem('activeRole') } catch (e) { /* noop */ }
    window.location.href = '/';
    return true;
  } catch (e) {
    localStorage.removeItem('impersonate_backup');
    return false;
  }
};

// پیامِ «در حال به‌روزرسانی» را یک‌بار به کاربر نشان بده (۵۰۳ از سرور)
let _updatingToastAt = 0;
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const data = err && err.response && err.response.data;
    const upd = data && data.updating;
    if (upd) {
      const now = Date.now();
      if (now - _updatingToastAt > 8000) {
        _updatingToastAt = now;
        const f = document.createElement('div');
        f.dir = 'rtl';
        f.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);' +
          'z-index:2147483647;background:#1a237e;color:#fff;padding:12px 20px;border-radius:12px;' +
          'font:14px/1.9 Tahoma,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.28);max-width:90vw;text-align:center';
        f.textContent = (data.detail || 'در حال به‌روزرسانی اطلاعات…') +
          ' (تلاش خودکار مجدد)';
        document.body.appendChild(f);
        setTimeout(() => f.remove(), 6000);
      }
    }
    return Promise.reject(err);
  }
);

api.interceptors.request.use(
  (config) => {
    const authPaths = ['/users/login/', '/users/refresh/', '/users/otp/request/', '/users/otp/verify/'];
    const isAuthPath = authPaths.some(path => config.url.includes(path));

    if (!isAuthPath) {
      const access = localStorage.getItem('access');
      if (access) {
        config.headers.Authorization = `Bearer ${access}`;
      }

      const activeRole = sessionStorage.getItem('activeRole');
      if (activeRole) {
        config.headers['X-Active-Role'] = activeRole;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      const isAuthPath = originalRequest.url.includes('/users/login/') || 
                         originalRequest.url.includes('/users/refresh/');

      if (isAuthPath) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          waiters.push({ resolve, reject });
        }).then(() => api(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refresh = localStorage.getItem('refresh');
      if (!refresh) {
        isRefreshing = false;
        if (restoreImpersonation()) return Promise.reject(error);
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        const { data } = await api.post('users/refresh/', { refresh });

        localStorage.setItem('access', data.tokens.access);
        if (data.tokens.refresh) {
          localStorage.setItem('refresh', data.tokens.refresh);
        }

        axios.defaults.headers.common.Authorization = `Bearer ${data.tokens.access}`;

        waiters.forEach(({ resolve }) => resolve());
        waiters = [];

        return api(originalRequest);
      } catch (refreshError) {
        waiters.forEach(({ reject }) => reject(refreshError));
        waiters = [];

        if (restoreImpersonation()) return Promise.reject(refreshError);

        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        sessionStorage.removeItem('activeRole');

        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export { api };
export const initializeAPI = () => {};
export default api;